module.exports = __webpack_public_path__ + "static/code-sample-bfbc3ac909f345fe4a206be32628ef14.png";